import React, { useState, useEffect } from 'react';
import firebase from '../../../firebase';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import 'firebase/storage';
import backgroundImage from '../posts/img/coloseum.jpg';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

const CreatePost = ({ user }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [tags, setTags] = useState([]); // Available tags
  const [selectedTags, setSelectedTags] = useState([]); // Selected tags
  const navigate = useNavigate();
  const [imageURL, setImageURL] = useState('');
  const [image, setImage] = useState('');
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({ title: false, content: false, image: false });

  useEffect(() => {
    // Fetch tags from tags.json
    fetch('/tags.json')
      .then(response => response.json())
      .then(data => setTags(data))
      .catch(error => console.error('Error fetching tags:', error));
  }, []);

  const handleCreatePost = async (e) => {
    e.preventDefault();
    setFieldErrors({ title: false, content: false, image: false });
    setErrorMessage('');

    if (!title || !content || !image || selectedTags.length === 0) {
      setFieldErrors({ title: !title, content: !content, image: !image });
      setErrorMessage('Please fill in all fields and select at least one tag.');
      return;
    }

    let imageUrl = '';
    if (image) {
      try {
        const storage = getStorage();
        const metadata = { contentType: 'image/jpeg' };
        const imageName = `${Date.now()}${user.uid}`;
        const storageRef = ref(storage, `images/${imageName}`);
        const uploadTask = uploadBytesResumable(storageRef, image, metadata);

        // Wait for the upload to complete
        await new Promise((resolve, reject) => {
          uploadTask.on(
            'state_changed',
            null,
            (error) => reject(error),
            () => {
              getDownloadURL(uploadTask.snapshot.ref)
                .then((downloadURL) => {
                  imageUrl = downloadURL;
                  resolve();
                })
                .catch((error) => reject(error));
            }
          );
        });
      } catch (error) {
        setErrorMessage('Error uploading image. Please try again.');
        return;
      }
    }

    const newDate = new Date();
    const timeStamp = `${Date.now()}`;
    const formattedContent = content.replace(/\n/g, '<br/>');

    try {
      await firebase.firestore().collection('Posts').add({
        title,
        content: formattedContent,
        imageURL: imageUrl,
        author: user.uid,
        timeStamp,
        tags: selectedTags,
      });
      setTitle('');
      setContent('');
      setImage('');
      setSelectedTags([]);
      navigate('/');
      window.location.reload();
    } catch (error) {
      setErrorMessage('Error creating post. Please try again.');
    }
  };

  const handleAddTag = (tag) => {
    if (selectedTags.length < 5 && !selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag]);
      setErrorMessage(''); // Clear the error message when a valid tag is added
    } else if (selectedTags.includes(tag)) {
      setErrorMessage('Tag already added.');
    } else {
      setErrorMessage('You can add up to 5 tags only.');
    }
  };

  const handleRemoveTag = (tag) => {
    setSelectedTags(selectedTags.filter((t) => t !== tag));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ['image/jpeg', 'image/png'];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes

      if (!validTypes.includes(file.type)) {
        setErrorMessage('Only JPEG and PNG formats are allowed.');
        setImage(null);
        return;
      }

      if (file.size > maxSize) {
        setErrorMessage('File size must be less than 2MB.');
        setImage(null);
        return;
      }

      setImage(file);
      setErrorMessage(''); // Clear any previous error messages
    }
  };

  return (
    <div>
      <img src={backgroundImage} alt="Background" className="background-image-add" />
      <div className="create-post-container">
        <h2>Pridaj článok</h2>
        <input
          type="text"
          style={{ borderColor: fieldErrors.title ? 'red' : '' }}
          placeholder="Názov, dĺžka max. 90 písmen"
          maxLength="90"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          style={{ borderColor: fieldErrors.content ? 'red' : '' }}
          placeholder="Tu napíš telo článku. Veľkosť okna zmeníš potiahnutím pravého dolného rohu"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <input
          type="file"
          style={{ borderColor: fieldErrors.image ? 'red' : '' }}
          placeholder="prehľadávaj"
          onChange={handleImageChange}
          accept="image/*"
        />

          <div className="tag-container">
            <select
              className="form-control dynamic-width-select-1 centered-select"
              onChange={(e) => handleAddTag(e.target.value)}
              value=""
            >
              <option value="" disabled>
                Pridaj Tag
              </option>
              {tags.map((tag, index) => (
                <option key={index} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
          </div>

          {/* Display selected tags */}
          <div className="selected-tags">
            {selectedTags.map((tag, index) => (
              <div key={index} className="tag-item">
                {tag}
                <button onClick={() => handleRemoveTag(tag)} className="remove-tag-button">
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Submit button and error message */}
          <button className="submit-button" onClick={handleCreatePost}>
            Hoď ho tam
          </button>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          </div>
          </div>
  );
};

export default CreatePost;